import { PersonSimpleRun } from '@phosphor-icons/react'
import useSessionStore from 'Context/useSessionStore'
import { GET_COLOR_BY_THEME } from 'constant/colors'

// Floating bar for bulk actions on selected rows. Fixed to the bottom of the
// viewport so it stays reachable regardless of scroll position or page size.
const SelectionActionBar = ({ count, reactivate, onAction, onClear }) => {
  const { user } = useSessionStore((state) => ({ user: state.user }))

  return (
    <div className="selection-action-bar" role="toolbar" aria-label="Bulk user actions">
      <span className="selection-action-bar-count">{count} selected</span>
      <button type="button" className="btn btn-secondary btn-sm selection-action-bar-clear" onClick={onClear}>
        Clear
      </button>
      <button
        type="button"
        className={`btn btn-sm selection-action-bar-deactivate ${reactivate ? 'btn-primary' : 'btn-danger'}`}
        onClick={onAction}>
        <PersonSimpleRun
          size={16}
          weight="bold"
          className="me-2"
          style={reactivate ? { transform: 'scaleX(-1)' } : undefined}
          color={reactivate ? GET_COLOR_BY_THEME({ theme: user.theme }).PRIMARY : undefined}
        />
        {reactivate ? 'Reactivate' : 'Deactivate'} {count > 1 ? `${count} users` : 'user'}
      </button>
    </div>
  )
}

export default SelectionActionBar
